import { useSalesOrderContractTask } from '@/hooks/api/1660_sales_order_contract_task';
import { TeamMemberLogic } from '@/hooks/api/models/logics';
import { toastError } from '@/lib/toast';
import { useCurrentSalesOrderContractTask } from '@/providers/SalesOrderContractTaskProvider';
import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useEffect } from 'react';
import { Navigate, useLocation, useParams } from 'react-router-dom';

type Props = { children?: React.ReactNode };

export const RequireSalesOrderContractTask = (props: Props) => {
  const location = useLocation();
  const { meTeamMember } = useCurrentTeamMember();
  const { identifier, team_id, sales_order_id, sales_order_contract_task_id } = useParams();
  const { data, status } = useSalesOrderContractTask({
    identifier: identifier!,
    team_id: Number(team_id!),
    sales_order_id: Number(sales_order_id!),
    id: Number(sales_order_contract_task_id!),
  });
  const { salesOrderContractTask, setSalesOrderContractTask } = useCurrentSalesOrderContractTask();

  useEffect(() => {
    if (data) {
      setSalesOrderContractTask((_) => data);
    }
  }, [data]);

  if (status == 'error') {
    toastError('アクセス出来ませんでした。');
    return <Navigate replace to={`/w/${identifier}`} />;
  }

  // backoffice権限のみの場合
  if (meTeamMember && TeamMemberLogic.hasBackofficeOnlyRole(meTeamMember!)) {
    // urlがプロジェクト配下のurlの場合は、backoffice配下のurlに遷移
    if (location.pathname.startsWith(`/w/${identifier}/teams/`)) {
      return (
        <Navigate
          replace
          to={`/w/${identifier}/backoffice/teams/${team_id}/sales_orders/${sales_order_id}/sales_order_contract_tasks/${sales_order_contract_task_id}`}
        />
      );
    }
  }

  if (salesOrderContractTask) {
    return <>{props.children}</>;
  }

  return <></>;
};
